import { mergeAttributes } from '@tiptap/core';
import Mention from '@tiptap/extension-mention';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import RichTextMention from '../components/all/RichTextMention.vue';

const CustomMention = Mention.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      id: {
        default: null,
        parseHTML: element => element.getAttribute('data-id'),
        renderHTML: attributes => {
          if (!attributes.id) {
            return {};
          }

          return {
            'data-id': attributes.id,
          };
        },
      },
      type: {
        default: null,
        parseHTML: element => element.getAttribute('data-type'),
        renderHTML: attributes => {
          if (!attributes.type) {
            return {};
          }

          return {
            'data-type': attributes.type,
          };
        },
      },
      label: {
        default: null,
        parseHTML: element =>
          element.getAttribute('data-label')
            ? element.getAttribute('data-label')
            : element.innerText,
        renderHTML: attributes => {
          if (!attributes.label) {
            return {};
          }
          return {
            'data-label': attributes.label,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: `span[data-id]`,
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(
        {
          class: `mention-${node.attrs.type}`,
        },
        this.options.HTMLAttributes,
        HTMLAttributes
      ),
      this.options.renderLabel({ options: this.options, node }),
    ];
  },

  addNodeView() {
    return VueNodeViewRenderer(RichTextMention);
  },

  addCommands() {
    return {
      ...this.parent?.(),
      isSuggestionActive: () => ({ commands }) => {
        return this.options.suggestion.isPopupActive();
      },
    };
  },
});

export default CustomMention;
